import { schreibStatusAnzeige, tagText, type SchreibZusammenfassung } from '../lauf';
import type { SchreibErgebnis } from '../typen';

const AUFKLAPP_AB = 10;

/**
 * Plenty-Schreibergebnis eines Laufs (Zeile, Warnungen, Tabelle je Auftrag).
 * Alle Backend-Texte (fehler, grund) werden als React-Textknoten gerendert.
 */
export default function PlentyUebersicht({
  schreiben,
  z,
}: {
  schreiben: SchreibErgebnis | null | undefined;
  /** Ergebnis von schreibZusammenfassung(schreiben), vom Aufrufer berechnet. */
  z: SchreibZusammenfassung;
}) {
  const auftraege = schreiben?.auftraege ?? [];

  const tabelle = (
    <table className="w-full text-sm border border-[#DAD9D9] bg-white">
      <thead className="bg-[#DAD9D9] text-[#1A1A1A]">
        <tr>
          <th className="px-3 py-2 text-left">Auftrag</th>
          <th className="px-3 py-2 text-left">Status</th>
          <th className="px-3 py-2 text-left">Tags (Soll → geschrieben)</th>
          <th className="px-3 py-2 text-left">Grund / Fehler</th>
        </tr>
      </thead>
      <tbody>
        {auftraege.map((a) => {
          const anzeige = schreibStatusAnzeige(a.status, schreiben?.zielStatus);
          return (
            <tr key={a.orderId} className="border-t border-[#DAD9D9]">
              <td className="px-3 py-2">{a.orderId}</td>
              <td className="px-3 py-2">
                <span className={`px-2 py-0.5 rounded text-xs ${anzeige.klasse}`}>{anzeige.text}</span>
              </td>
              <td className="px-3 py-2">
                {tagText(a.tagsSoll)} → {tagText(a.tagsGeschrieben)}
                {a.tagsFehler && <div className="text-red-800">{a.tagsFehler}</div>}
              </td>
              <td className="px-3 py-2 text-red-800">
                {a.fehler ?? a.grund ?? ''}
                {(a.hinweise ?? []).length > 0 && (
                  <ul className="list-disc pl-5 text-xs text-[#1A1A1A]">
                    {(a.hinweise ?? []).map((h, i) => (
                      <li key={`${i}-${h}`}>{h}</li>
                    ))}
                  </ul>
                )}
                {schreiben?.schreibStopp?.auftrag === a.orderId && (a.propertiesVorher ?? []).length > 0 && (
                  <details className="text-[#1A1A1A]">
                    <summary className="cursor-pointer">Eigenschaften vor dem PUT (zur Wiederherstellung)</summary>
                    <ul className="list-disc pl-5 text-xs">
                      {(a.propertiesVorher ?? []).map((p, i) => (
                        <li key={`${p.typeId}-${i}`}>
                          typeId {p.typeId}: {p.value}
                        </li>
                      ))}
                    </ul>
                  </details>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  return (
    <section className="space-y-2 text-sm">
      <h3 className="font-semibold text-[#1A1A1A]">Plenty</h3>
      <p className={z.gesperrt ? 'p-2 rounded bg-yellow-50 text-yellow-900' : ''}>{z.zeile}</p>
      {schreiben?.fehler && <p className="p-2 rounded bg-red-50 text-red-800">{schreiben.fehler}</p>}
      {z.warnungen.map((w) => (
        <p key={w} className="p-2 rounded bg-red-50 text-red-800">
          {w}
        </p>
      ))}
      {auftraege.length > AUFKLAPP_AB ? (
        <details>
          <summary className="cursor-pointer">Aufträge ({auftraege.length})</summary>
          {tabelle}
        </details>
      ) : (
        auftraege.length > 0 && tabelle
      )}
    </section>
  );
}
